module.exports = __webpack_public_path__ + "static/media/Growing-03.0716a7ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/Growing-03.png
// module id = 203
// module chunks = 0